// extracted by mini-css-extract-plugin
module.exports = {"captchaContainer":"ReCaptchaComponent_captchaContainer__1fE5K"};